import { render, staticRenderFns } from "./empty-content.vue?vue&type=template&id=01bc5175&scoped=true&"
import script from "./empty-content.vue?vue&type=script&lang=js&"
export * from "./empty-content.vue?vue&type=script&lang=js&"
import style0 from "./empty-content.vue?vue&type=style&index=0&id=01bc5175&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bc5175",
  null
  
)

export default component.exports